<script setup lang="ts">
import { onMounted } from 'vue';
import SmarticoTournaments from '@/components/smartico/apostatudo/Tournaments.vue';
import useSeo from '@/composables/useSeo';
import { getStandardSeoSuffixes } from '@/utils/seoConstants';

const { standardTitleSuffix } = getStandardSeoSuffixes();

useSeo({
  title: `Torneios ${standardTitleSuffix}`,
});

onMounted(() => {
  // Mark that we're on a tournament page, so when user goes back, filters can be restored
  if (typeof window !== 'undefined') {
    try {
      sessionStorage.setItem('casino_navigation_from_game', 'true');
    } catch (e) {
      // Ignore storage errors
    }
  }
});
</script>

<template>
  <div :class="$style.centerPage">
    <SmarticoTournaments />
  </div>
</template>

<style module lang="postcss">
.centerPage {
  @apply w-full min-h-[600px] flex flex-col relative -mt-1 lg:-mt-4;
}
</style>
